export default "__VITE_ASSET__UmshM0sT__"